import { Component } from '@angular/core';

@Component({
  selector: 'app-unit-details-info',
  templateUrl: './unit-details-info.component.html',
  styleUrls: ['./unit-details-info.component.scss']
})
export class UnitDetailsInfoComponent {

}
